exports.components = {
  "component---src-pages-cenik-js": () => import("./../../../src/pages/cenik.js" /* webpackChunkName: "component---src-pages-cenik-js" */),
  "component---src-pages-fotogalerie-js": () => import("./../../../src/pages/fotogalerie.js" /* webpackChunkName: "component---src-pages-fotogalerie-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-jidelnicek-js": () => import("./../../../src/pages/jidelnicek.js" /* webpackChunkName: "component---src-pages-jidelnicek-js" */),
  "component---src-pages-prihlasky-js": () => import("./../../../src/pages/prihlasky.js" /* webpackChunkName: "component---src-pages-prihlasky-js" */)
}

